<template>
  <div class="production">
    <!-- desckop -->
    <div class="production-header">
      <div class="production-header-content">
        <div class="production-header-content-logo">
          <i class="production-header-content-logo-icon"></i>
          <p class="production-header-content-logo-text">停車場管理系統</p>
        </div>
        <div class="production-header-content-action">
          <a
            class="production-header-content-action-link"
            href="http://partner.paca.com.tw"
            target="_blank"
          >
            <i class="production-header-content-action-link-icon partner"></i>
            <p class="production-header-content-action-link-text">合作夥伴</p>
          </a>
          <button
            type="button"
            class="production-header-content-action-link"
            @click="openConnectionDialog"
          >
            <i class="production-header-content-action-link-icon content"></i>
            <p class="production-header-content-action-link-text">聯絡我們</p>
          </button>
          <button
            type="button"
            class="production-header-action-button main-button"
            @click="openDrawerOpen('login')"
          >
            登入
          </button>
        </div>
      </div>
    </div>
    <div class="production-content">
      <div class="production-content-item item-register">
        <div class="production-content-item-main">
          一表看懂所有現況，一站掌控所有資訊
        </div>
        <div class="production-content-item-text">
          整合現場系統資訊，將您所有的場站、憑證集中管理，
        </div>
        <div class="production-content-item-text">
          輕鬆查看所有資料，精準掌握場站狀態
        </div>
        <button
          type="button"
          class="production-content-item-footer main-button"
          @click="openDrawerOpen('register')"
        >
          免費註冊
        </button>
      </div>
      <div class="production-content-item item-report">
        <div class="production-content-item-image item-report"></div>
      </div>
      <div class="production-content-item item-chart">
        <div class="production-content-item-image item-chart"></div>
      </div>
      <div class="production-content-item item-token">
        <div class="production-content-item-image item-token"></div>
      </div>
      <div class="production-content-item item-integration">
        <div class="production-content-item-image item-intergration"></div>
      </div>
    </div>
    <div class="production-footer">
      <div class="production-footer-title">聯絡我們</div>
      <div class="production-footer-content">
        <div class="production-footer-content-item">
          <div class="production-footer-content-item-icon email"></div>
          <div class="production-footer-content-item-text">
            <p class="production-footer-content-item-text-main">
              service@berryan.com
            </p>
            <p class="production-footer-content-item-text-second">
              歡迎來信洽詢任何問題，我們會盡快回覆
            </p>
          </div>
        </div>
        <div class="production-footer-content-item">
          <div class="production-footer-content-item-icon phone"></div>
          <div class="production-footer-content-item-text">
            <p class="production-footer-content-item-text-main">02-26968766</p>
            <p class="production-footer-content-item-text-second">
              請於上班時間來電
            </p>
            <p class="production-footer-content-item-text-second">
              周一 ~ 周五 9:00am ~ 6:00pm
            </p>
          </div>
        </div>
        <div class="production-footer-content-item">
          <div class="production-footer-content-item-icon address"></div>
          <div class="production-footer-content-item-text">
            <p class="production-footer-content-item-text-main">
              新北市汐止區新台五路一段106號18樓
            </p>
            <p class="production-footer-content-item-text-second">
              泊律恆有限公司
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      class="production-drawer"
      :visible.sync="isDrawerOpen"
      :wrapperClosable="false"
      size="unset"
    >
      <div class="production-drawer-body">
        <div class="production-drawer-body-header">
          <button
            type="button"
            class="production-drawer-body-header-page"
            :class="{ 'is-check': loginEvent == 'login' }"
            v-if="loginEvent != 'forget'"
            @click="changePage('login')"
          >
            用戶登入
          </button>
          <button
            type="button"
            class="production-drawer-body-header-page"
            :class="{ 'is-check': loginEvent == 'register' }"
            v-if="loginEvent != 'forget'"
            @click="changePage('register')"
          >
            註冊帳號
          </button>
          <button
            type="button"
            class="production-drawer-body-header-page forget"
            :class="{ 'is-check': loginEvent == 'forget' }"
            v-if="loginEvent == 'forget'"
          >
            忘記密碼
          </button>
        </div>
        <form @keyup.enter.prevent class="production-drawer-body-content">
          <div v-if="loginEvent == 'login'" @keyup.enter="postUserLogin">
            <lgn-form-item
              class="production-drawer-body-content-item"
              labelPosition="top"
            >
              <div
                slot="label"
                class="production-drawer-body-content-item-label"
              >
                Email 帳號
              </div>
              <lgn-input
                slot="input"
                class="production-drawer-body-content-item-value"
                v-model="loginInfo.email"
                autofocus
              ></lgn-input>
            </lgn-form-item>
            <lgn-form-item
              class="production-drawer-body-content-item"
              labelPosition="top"
            >
              <div
                slot="label"
                class="production-drawer-body-content-item-label"
              >
                使用者密碼
              </div>
              <lgn-input
                type="password"
                slot="input"
                class="production-drawer-body-content-item-value"
                v-model="loginInfo.password"
              ></lgn-input>
            </lgn-form-item>
            <div class="production-drawer-body-content-supplement">
              <el-checkbox
                class="production-drawer-body-content-supplement-checkbox"
                v-model="remember"
                :true-label="1"
                :false-label="0"
                >記住我</el-checkbox
              >
              <button
                type="button"
                class="production-drawer-body-content-supplement-forget"
                @click="changePage('forget')"
              >
                忘記密碼
              </button>
            </div>
          </div>
          <div v-else-if="loginEvent == 'register'" @keyup.enter="postSignIn">
            <lgn-form-item
              class="production-drawer-body-content-item"
              labelPosition="top"
            >
              <div
                slot="label"
                class="production-drawer-body-content-item-label"
              >
                Email 帳號
              </div>
              <lgn-input
                slot="input"
                class="production-drawer-body-content-item-value"
                v-model="signInInfo.email"
              ></lgn-input>
            </lgn-form-item>
            <lgn-form-item
              class="production-drawer-body-content-item"
              labelPosition="top"
            >
              <div
                slot="label"
                class="production-drawer-body-content-item-label"
              >
                使用者密碼
              </div>
              <lgn-input
                type="password"
                slot="input"
                class="production-drawer-body-content-item-value"
                placeholder="至少 8 個英數字"
                v-model="signInInfo.password"
              ></lgn-input>
            </lgn-form-item>
          </div>
          <div v-else @keyup.enter.stop="postForgetPassword">
            <lgn-form-item
              class="production-drawer-body-content-item"
              labelPosition="top"
            >
              <div
                slot="label"
                class="production-drawer-body-content-item-label"
              >
                Email 帳號
              </div>
              <lgn-input
                slot="input"
                class="production-drawer-body-content-item-value"
                v-model="forgetInfo.email"
              ></lgn-input>
            </lgn-form-item>
            <lgn-form-item
              class="production-drawer-body-content-item"
              labelPosition="top"
            >
              <div
                slot="label"
                class="production-drawer-body-content-item-label"
              >
                新密碼
              </div>
              <lgn-input
                type="password"
                slot="input"
                class="production-drawer-body-content-item-value"
                placeholder="至少 8 個英數字"
                v-model="forgetInfo.password"
              ></lgn-input>
            </lgn-form-item>
          </div>
        </form>
        <div class="production-drawer-body-footer">
          <button
            type="button"
            class="production-drawer-body-footer-button main-button"
            v-if="loginEvent == 'login'"
            @click="postUserLogin"
          >
            登入
          </button>
          <button
            type="button"
            class="production-drawer-body-footer-button main-button"
            v-if="loginEvent == 'register'"
            @click="postSignIn"
          >
            註冊
          </button>
          <button
            type="button"
            class="production-drawer-body-footer-button main-button"
            v-if="loginEvent == 'forget'"
            @click="postForgetPassword"
          >
            送出
          </button>
        </div>
        <div class="production-drawer-body-mobile">
          <a
            href="http://partner.paca.com.tw"
            target="_blank"
            class="production-drawer-body-mobile-item"
            >合作夥伴</a
          >
          <button
            type="button"
            class="production-drawer-body-mobile-item"
            @click="openConnectionDialog"
          >
            聯絡我們
          </button>
        </div>
      </div>
    </el-drawer>
    <el-dialog class="connection-dialog" :visible.sync="isConnectionOpen">
      <div slot="title">聯絡我們</div>
      <div class="connection-dialog__body">
        <div class="connection-dialog__body-item">
          <div class="connection-dialog__body-item-label">信箱</div>
          <a
            href="mailto: service@berryan.com"
            class="connection-dialog__body-item-value"
            >service@berryan.com</a
          >
        </div>
        <div class="connection-dialog__body-item">
          <div class="connection-dialog__body-item-label">電話</div>
          <a href="tel: 0226968766" class="connection-dialog__body-item-value"
            >02-26968766</a
          >
        </div>
      </div>
      <div slot="footer">
        <button
          type="button"
          class="connection-dialog__footer-button main-button"
          @click="closeConnectionDialog()"
        >
          確認
        </button>
      </div>
    </el-dialog>
    <!--mobile -->
    <div class="production-mobile">
      <div class="production-mobile-header">
        <div class="production-mobile-header-logo">
          <div class="production-mobile-header-logo-icon"></div>
          <div class="production-mobile-header-logo-text">停車場管理系統</div>
        </div>
        <div class="production-mobile-header-action">
          <button
            type="button"
            class="production-mobile-header-action-button main-button"
            @click="openDrawerOpen('login')"
          >
            登入
          </button>
        </div>
      </div>
      <div class="production-mobile-content">
        <div class="production-mobile-content-item item-register">
          <div class="production-mobile-content-item-main">
            一表看懂所有現況<br />一站掌控所有資訊
          </div>
          <div class="production-mobile-content-item-text">
            整合現場系統資訊<br />將您所有的場站、憑證集中管理，
          </div>
          <div class="production-mobile-content-item-text">
            輕鬆查看所有資料，精準掌握場站狀態
          </div>
          <button
            type="button"
            class="production-mobile-content-item-footer main-button"
            @click="openDrawerOpen('register')"
          >
            免費註冊
          </button>
        </div>
        <div class="production-mobile-content-item item-report">
          <div class="production-mobile-content-item-image item-report"></div>
        </div>
        <div class="production-mobile-content-item item-chart">
          <div class="production-mobile-content-item-image item-chart"></div>
        </div>
        <div class="production-mobile-content-item item-token">
          <div class="production-mobile-content-item-image item-token"></div>
        </div>
        <div class="production-mobile-content-item item-integration">
          <div
            class="production-mobile-content-item-image item-intergration"
          ></div>
        </div>
      </div>
      <div class="production-mobile-footer">
        <div class="production-mobile-footer-title">聯絡我們</div>
        <div class="production-mobile-footer-content">
          <div class="production-mobile-footer-content-item">
            <div class="production-mobile-footer-content-item-icon email"></div>
            <div class="production-mobile-footer-content-item-text">
              <p class="production-mobile-footer-content-item-text-main email">
                service@berryan.com
              </p>
            </div>
          </div>
          <div class="production-mobile-footer-content-item">
            <div class="production-mobile-footer-content-item-icon phone"></div>
            <div class="production-mobile-footer-content-item-text">
              <p class="production-mobile-footer-content-item-text-main">
                02-26968766
              </p>
              <p class="production-mobile-footer-content-item-text-second">
                請於上班時間來電
              </p>
              <p class="production-mobile-footer-content-item-text-second">
                周一 ~ 周五 9:00am ~ 6:00pm
              </p>
            </div>
          </div>
          <div class="production-mobile-footer-content-item">
            <div
              class="production-mobile-footer-content-item-icon address"
            ></div>
            <div class="production-mobile-footer-content-item-text address">
              <p class="production-mobile-footer-content-item-text-main">
                新北市汐止區新台五路一段106號18樓
              </p>
              <p class="production-mobile-footer-content-item-text-second">
                泊律恆有限公司
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import lgnFormItem from "@/lgnComponents/lgnForm/lgnFormItem.vue";
  import lgnInput from "@/lgnComponents/lgnInput/lgnInput.vue";
  import * as api from "@/script/apiService/api.js";
  export default {
    components: { lgnFormItem, lgnInput },
    name: "production",
    data() {
      return {
        isDrawerOpen: false,
        loginEvent: "login",
        remember: 0,
        loginInfo: {
          email: "",
          password: "",
        },
        signInInfo: {
          email: "",
          password: "",
        },
        forgetInfo: {
          email: "",
          password: "",
        },
        root: process.env.VUE_APP_PACACLOUND_ROOT,
        isConnectionOpen: false,
        mobileLogin: 0,
        isHeaderListOpen: false,
      };
    },
    methods: {
      async postUserLogin() {
        if (this.remember == 0) {
          localStorage.removeItem("memberEmail");
        } else {
          localStorage.setItem("memberEmail", this.loginInfo.email);
        }
        let res = await api.postUserLogin(
          this.loginInfo.email,
          this.loginInfo.password
        );
        if (!res.error_status) {
          this.isDrawerOpen = false;
          if (res.is_partner == 1) {
            this.$store.commit({
              type: "setUserInfo",
              userInfo: null,
            });
            this.$message.error({
              duration: 2500,
              showClose: true,
              message: this.$t("login.login.accountInfoError"),
            });
            return false;
          }
          this.$router.push({ name: "Home" });
        } else {
          this.$message.error({
            duration: 2500,
            showClose: true,
            message: this.$t("login.login.accountInfoError"),
          });
        }
      },
      async postSignIn() {
        let res = await api.postSignIn(
          this.signInInfo.email,
          this.signInInfo.password
        );
        if (!res.error_status) {
          this.$message.success({
            duration: 2500,
            showClose: true,
            message: "請至Email收信, 並點擊啟用帳號",
          });
          this.changePage("login");
        } else if (res.error_status == "400") {
          this.$message.error({
            duration: 2500,
            showClose: true,
            message: "請確認輸入的內容!",
          });
        } else if (res.error_status == "409") {
          this.$message.info({
            duration: 2500,
            showClose: true,
            message: "此帳號已註冊過!",
          });
        } else if (res.error_status != "401" && res.error_status != "504") {
          this.$message.error({
            duration: 2500,
            showClose: true,
            message: "發生錯誤!",
          });
        }
      },
      async postForgetPassword() {
        let res = await api.postForgetPassword(
          this.forgetInfo.email,
          this.forgetInfo.password
        );
        if (!res.error_status) {
          this.$message.success({
            duration: 2500,
            showColse: true,
            message: "請至您的電子信箱確認",
          });
          this.changePage("login");
        } else if (res.error_status == "400") {
          this.$message.error({
            duration: 2500,
            showColse: true,
            message: "密碼不符合條件!",
          });
        } else if (res.error_status == "404") {
          this.$message.error({
            duration: 2500,
            showColse: true,
            message: "此信箱尚未註冊!",
          });
        } else if (res.error_status != "401" && res.error_status != "504") {
          this.$message.error({
            duration: 2500,
            showColse: true,
            message: "發生錯誤!",
          });
        }
      },
      openDrawerOpen(type) {
        this.loginEvent = type;
        this.isDrawerOpen = true;
        if (type == "register") {
          this.signInInfo.email = "";
          this.$nextTick(() => {
            setTimeout(
              function() {
                document.querySelectorAll(".el-drawer__body input")[0].focus();
              }.bind(this),
              500
            );
          });
        } else if (type == "login" && this.remember == 0) {
          this.loginInfo.email = "";
          this.$nextTick(() => {
            setTimeout(
              function() {
                document.querySelectorAll(".el-drawer__body input")[0].focus();
              }.bind(this),
              500
            );
          });
        } else {
          this.$nextTick(() => {
            setTimeout(
              function() {
                document.querySelectorAll(".el-drawer__body input")[1].focus();
              }.bind(this),
              500
            );
          });
        }
      },
      changePage(page) {
        this.loginEvent = page;
        if (page == "login") {
          page += "Info";
          this[page].password = "";
          if (this.remember == 0) {
            this[page].email = "";
            this.$nextTick(() => {
              document.querySelectorAll(".el-drawer__body input")[0].focus();
            });
          } else {
            this.$nextTick(() => {
              document.querySelectorAll(".el-drawer__body input")[1].focus();
            });
          }
        } else if (page == "forget") {
          page += "Info";
          this[page].email = this.loginInfo.email;
          this[page].password = "";
          if (this[page].email.length == 0) {
            this.$nextTick(() => {
              document.querySelectorAll(".el-drawer__body input")[0].focus();
            });
          } else {
            this.$nextTick(() => {
              document.querySelectorAll(".el-drawer__body input")[1].focus();
            });
          }
        } else {
          page = "signInInfo";
          this[page].email = "";
          this[page].password = "";
          this.$nextTick(() => {
            document.querySelectorAll(".el-drawer__body input")[0].focus();
          });
        }
      },
      openConnectionDialog() {
        this.isConnectionOpen = true;
      },
      closeConnectionDialog() {
        this.isConnectionOpen = false;
      },
    },
    mounted() {
      this.isHeaderListOpen = false;
      let localStorageEmail = localStorage.getItem("memberEmail");
      if (localStorageEmail) {
        this.loginInfo.email = localStorageEmail;
        this.remember = 1;
      }
    },
  };
</script>
